import { Injectable } from '@angular/core';
import { CountryService } from './country.service';
import { ICountryModel } from './country';

@Injectable()
export class FiCountryHelperService {
    private _countryModels: ICountryModel[] = [];
    private readonly countryIconPath: string = '/Content/Images/FlagIcons/{code}.png';

    constructor(private countryService: CountryService) {}

    getCountryCodes(): Promise<ICountryModel[]> {
        return new Promise((resolve, reject) => {
            if (!!this._countryModels.length) return resolve(this._countryModels);

            this.countryService.GetCountryCodes().then((countries: ICountryModel[]) => {
                this._countryModels = countries;
                return resolve(this._countryModels);
            }, reject);
        });
    }

    private readonly _fiUserCountryCodeStorageKey: string = 'fi-user-country-code';
    saveUserCountryModel(countryModel: ICountryModel) {
        localStorage.setItem(this._fiUserCountryCodeStorageKey, JSON.stringify(countryModel));
    }

    getCountryByUserLocation(): Promise<ICountryModel> {
        return new Promise((resolve, reject) => {
            const savedCountryModel: string = localStorage.getItem(this._fiUserCountryCodeStorageKey);

            if (savedCountryModel) return resolve(JSON.parse(savedCountryModel));

            this.countryService.GetCountryByUserLocation().then((country: ICountryModel) => {
                this.saveUserCountryModel(country);
                return resolve(country);
            }, reject);
        });
    }

    refreshCountryCodes() {
        this._countryModels = [];
    }

    getCountryFlagUrl(countryIsoTwoCode: string): string {
        return `url(${this.getCountryFlagUrlPath(countryIsoTwoCode)})`;
    }

    getCountryFlagUrlPath(countryIsoTwoCode: string): string {
        return countryIsoTwoCode ? this.countryIconPath.format({ '{code}': countryIsoTwoCode }) : '';
    }
}
